<template>
  <div>
    <SectionTitle content="Ic. Información de la Cita" :has-line="true" />
    <div class="row mb-4 px-2">
      <div class="col-md-3">
        <div class="d-flex my-3 flex-column">
          <label class="text-muted">Número de Cita:</label>
          <span>
            {{ studentInfo?.studentInformationAppointment?.appointmentId }}
          </span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex my-3 flex-column">
          <label class="text-muted">Estatus de Cita:</label>
          <span>{{ studentInfo?.studentInformationAppointment?.status }}</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex my-3 flex-column">
          <label class="text-muted">Fecha de Cita:</label>
          <span>
            {{
              studentInfo?.studentInformationAppointment?.date != null
                ? formatDate(studentInfo?.studentInformationAppointment?.date)
                : ''
            }}
          </span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex my-3 flex-column">
          <label class="text-muted">Días desde que ocurrió la cita:</label>
          <span>
            {{ studentInfo?.studentInformationAppointment?.daysPasses }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomInput from 'CustomInput';
import moment from 'moment';

export default {
  components: {
    SectionTitle,
    CustomInput,
  },
  props: {
    studentInfo: {
      type: Object,
      default: {
        studentInformationAppointment: {},
      },
    },
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
